var _style, _g, _rect, _path, _circle, _circle2, _circle3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAtlas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 105.6 32",
    style: {
      enableBackground: "new 0 0 105.6 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000026160100884712522560000013055465707126543546_);}\n\t.st3{fill:url(#SVGID_00000148630888089429062990000018167082991387432629_);}\n\t.st4{fill:url(#SVGID_00000000904710433329429850000013200844249756064394_);}\n\t.st5{fill:url(#SVGID_00000181060916982967872940000002621750908828744344_);}\n\t.st6{fill:url(#SVGID_00000093162740941512848550000015901128799121988511_);}\n\t.st7{fill:url(#SVGID_00000057849483873790121770000010478452960762404506_);}\n\t.st8{fill:#2684FF;}\n\t.st9{fill:url(#SVGID_00000058589281336051354600000017719011822364263809_);}\n\t.st10{fill:url(#SVGID_00000044180052070782854330000008748927927213227926_);}\n\t.st11{fill:url(#SVGID_00000134950257228606530060000005522932693355798946_);}\n\t.st12{fill:url(#SVGID_00000049216687879001220850000018155705365062684326_);}\n\t.st13{fill:url(#SVGID_00000133529463711097424660000015047915391757007500_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 28,
    height: 28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.2469,
    y1: 6.7807,
    x2: 7.2569,
    y2: 32.7525,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2684FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0052CC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14,27C6.8,27,1,21.2,1,14S6.8,1,14,1v2.1C8,3.1,3.1,8,3.1,14S8,24.9,14,24.9V27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152943500326775106310000014286170567267767973_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.2214,
    y1: 18.8587,
    x2: 15.7114,
    y2: 6.9587,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0E65DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0052CC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152943500326775106310000014286170567267767973_)"
    },
    d: "M14,27v-2.1c6,0,10.9-4.9,10.9-10.9 H27C27,21.2,21.2,27,14,27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007402314849209956620000010020434623329038485_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.5,
    y1: 33,
    x2: 20.5,
    y2: 20,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2684FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#156EE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E65DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007402314849209956620000010020434623329038485_)"
    },
    d: "M27,14h-2.1C24.9,8,20,3.1,14,3.1V1 C21.2,1,27,6.8,27,14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043428865189959240280000015474823369894311308_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.1196,
    y1: 19.39,
    x2: 19.94,
    y2: 19.39,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#2684FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E65DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043428865189959240280000015474823369894311308_)"
    },
    d: "M19.5,18c-1.4-0.3-2.5-0.8-4.3-1.6 c-0.5-0.2-1.1-0.5-1.7-0.8c-0.4-0.2-0.7-0.3-1.1-0.5c-2.7-1.2-4.2-1.9-6.1-1.9c-1.3,0-2.3,0.4-2.8,1c-0.4,0.4-0.5,1-0.4,1.6 l-2,0.4C1,15.1,1.3,13.9,2,13c0.7-0.8,2-1.8,4.4-1.8c2.3,0,4.1,0.8,6.9,2.1c0.3,0.1,0.7,0.3,1.1,0.5c0.6,0.3,1.2,0.5,1.7,0.8 c1.7,0.8,2.7,1.2,3.8,1.4L19.5,18z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007423134195112681560000006230847586259500681_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.6187,
    y1: 16.3512,
    x2: 25.7287,
    y2: 20.7212,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0052CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E65DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007423134195112681560000006230847586259500681_)"
    },
    d: "M21.6,18.2c-0.7,0-1.4-0.1-2-0.2l0.4-2 c0.5,0.1,1.1,0.2,1.6,0.2c1.3,0,2.2-0.3,2.8-0.9c0.6-0.6,0.6-1.4,0.5-1.7l2.1-0.2c0.1,1.3-0.3,2.4-1.1,3.3 C25.2,17.3,23.9,18.2,21.6,18.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036239065889240220580000008418163097693028263_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.03,
    y1: 7,
    x2: 17.03,
    y2: 31.84,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#2684FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0052CC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036239065889240220580000008418163097693028263_)"
    },
    d: "M14,27v-2.1c3,0,4.7-3,4.7-8.1 s-1.8-9.3-5.5-13.2l1.5-1.4c4.1,4.3,6.1,9.1,6.1,14.7C20.8,23.1,18.2,27,14,27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048463695344975533430000012136872465987345071_",
    gradientUnits: "userSpaceOnUse",
    x1: -5583.855,
    y1: 7,
    x2: -5583.855,
    y2: 31.83,
    gradientTransform: "matrix(-1 0 0 -1 -5572.9902 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#2684FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#0052CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2684FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048463695344975533430000012136872465987345071_)"
    },
    d: "M14,27c-4.5,0-7-3.6-7-10 c0-7.4,3.2-11.6,6.3-14.8l1.5,1.4C11.2,7.4,9,11,9,17c0,6.6,2.7,7.9,5,7.9C14,24.9,14,27,14,27z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 8.5,
    cy: 12.7,
    r: 2.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 19.6,
    cy: 16.8,
    r: 2.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 14,
    cy: 2.4,
    r: 2.4
  })))), /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    className: "st0",
    width: 73.6,
    height: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001664974553470911410000009299560326868361390_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.8899,
    y1: 39.2203,
    x2: 32.2699,
    y2: 15.0003,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0052CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2684FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001664974553470911410000009299560326868361390_)"
    },
    d: "M38.2,19.7l-1.8,4.9H33l8.5-21.7h3.8 l8.5,21.7h-3.3l-1.8-4.9c-2,0.4-3.6,0.6-5.4,0.6C41.7,20.3,40,20.1,38.2,19.7L38.2,19.7z M47.8,17.2L43.4,5.3L39,17.3 c1.6,0.3,3,0.4,4.3,0.4C44.7,17.7,46.1,17.5,47.8,17.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032646954943489318810000009054091667316144265_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.0033,
    y1: -0.07108735,
    x2: 32.9917,
    y2: 23.3642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0052CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2684FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032646954943489318810000009054091667316144265_)"
    },
    d: "M61.5,22c0.7,0,1.3-0.1,1.8-0.2v2.7 c-0.5,0.1-1.1,0.3-1.9,0.3c-3.5,0-5.2-2.1-5.2-5.1v-8.8h-2.7V8.1h2.7V4.6h2.8v3.5h4.4v2.6h-4.4v8.8C58.9,21,59.8,22,61.5,22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099648939895825161570000009616576358048726933_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.85,
    y1: 33.4299,
    x2: 34.23,
    y2: 9.2099,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0052CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2684FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099648939895825161570000009616576358048726933_)"
    },
    d: "M70.9,24.7c-2.7,0-4.4-1.3-4.4-4.3 V1.2h2.8v18.9c0,1.5,1,2,2.2,2c0.3,0,0.5,0,0.8,0v2.5C72.1,24.7,71.6,24.7,70.9,24.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152974585083631712360000013197537405935133076_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.8956,
    y1: 21.4636,
    x2: 38.2756,
    y2: -2.7664,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0052CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2684FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152974585083631712360000013197537405935133076_)"
    },
    d: "M98.4,25c-2.5,0-4.5-0.6-5.7-1.2v-3 c1.4,0.8,3.8,1.6,5.9,1.6s3.3-0.9,3.3-2.2s-1-2-4.1-2.7c-3.7-0.9-5.2-2.3-5.2-5c0-2.9,2.2-4.6,6-4.6c2.2,0,4.1,0.5,5.3,1.2v2.9 c-2-1-3.6-1.5-5.3-1.5c-2.1,0-3.2,0.7-3.2,2c0,1.1,0.8,1.9,3.8,2.6c3.7,0.9,5.5,2.2,5.5,5.1S102.8,25,98.4,25L98.4,25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142888064326085260600000002432826439241542796_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.4592,
    y1: 25.7325,
    x2: 36.8392,
    y2: 1.5125,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0052CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2684FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142888064326085260600000002432826439241542796_)"
    },
    d: "M89.9,22.1c-0.8,0-1.2-0.3-1.2-1.4V8.1 h-2.8V11c-1-2.1-2.8-3.2-5.2-3.2c-4.6,0-6.9,3.9-6.9,8.6S76,25,80.5,25c2.8,0,4.4-1.2,5.5-3.4c0.2,2,1.5,3.1,3.3,3.1 c0.6,0,1,0,1.3-0.1V22C90.3,22.1,90.2,22.1,89.9,22.1L89.9,22.1z M85.9,17c0,3.7-2.3,5.3-4.8,5.3c-2.9,0-4.5-2-4.5-5.9 s1.7-5.9,4.8-5.9c2.4,0,4.5,1.6,4.5,5.3V17z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAtlas);
export default __webpack_public_path__ + "static/media/logo-atlas.910011b050a2ca52b38a5f9c35dd8649.svg";
export { ForwardRef as ReactComponent };